module.exports = __webpack_public_path__ + "img/xls.0d3e047c.png";